import { Grid, Typography, Box, Card, CardContent } from "@mui/material";

import ecocideBand from "../../../static/images/distant_bass_suite/overview.jpg"

const TEXT_COLOR = "#fff";

const QUOTE_PARAGRAPHS = [
  "While working on our new record, I wanted a bass sound that could hit just as hard in the studio as it does live.",
  "I needed something massive, aggressive and alive, a bass tone that could carry the weight of the guitars, but still cut through the mix with its own character. Something tight when it needs to be tight, but raw and violent when the music demands it.",
  "That idea became the foundation for the Distant BassSuite.",
  "The BassSuite is designed to deliver massive, aggressive and mix-ready bass tones without losing the raw energy and character of a real bass performance.",
  "It can go from a huge, thick modern bass sound to the filthy, destructive tones associated with old-school deathcore and extreme productions inspired by bands like Infant Annihilator.",
  "Too many digital bass tones can sound overly clean, polished or lifeless. The Bass Suite was built around the idea that heavy bass should feel physical, thick, dirty, aggressive and powerful.",
  "Whether you need a tight and punchy modern tone or a completely brutal wall of distortion, the Bass Suite gives you the tools to shape a bass sound that feels alive and dangerous.",
  "Because the heaviest records were never about sounding perfect. They were about energy, weight, aggression and impact.",
  "With the Bass Suite, you can bring that same power and character to your own bass recordings in the studio and on stage.",
];

const Paragraph = ({ title, children, smallTitle }) => {
  return <Box sx={{ mt: 2, textAlign: "left" }}>

    <Typography sx={{ fontSize: { md: "23px", xs: "16px" } }} variant="body2" ><b>{title}:</b> {children}</Typography>
  </Box>
}

const OverviewBanner = () => {
  return <Grid container sx={{
    width: "100%",
    pt: "80px",
    pb: { xs: 0, md: 20 },
    // minHeight: "100vh",
    backgroundSize: "cover",
    backgroundImage: "linear-gradient(rgba(0, 0, 0, 1.0) 0%, #1a1a1a 99%)",
  }}

    justifyContent={"center"} >

    <Grid item id="overview" xs={12} md={6} justifyContent={"center"} alignItems={"center"} sx={{ pl: { xs: 4, md: 10 }, pr: { xs: 4, md: 10 } }} >
      <Typography variant="h3" sx={{ mb: { xs: 2, md: 5 } }}>
        About the plugin
      </Typography>

      <Box component="blockquote" sx={{ m: 0, fontStyle: "italic" }}>
        {QUOTE_PARAGRAPHS.map((paragraph, index) => (
          <Typography key={index} component="p" sx={{ mb: 2, fontSize: { md: "23px", xs: "16px" } }} variant="body2">
            {index === 0 && "“"}{paragraph}{index === QUOTE_PARAGRAPHS.length - 1 && "”"}
          </Typography>
        ))}
        <Typography component="footer" sx={{ textAlign: "right", fontSize: { md: "23px", xs: "16px" } }} variant="body2">
          — Nouri Yetgin
        </Typography>
      </Box>

      <Typography sx={{ mt: { xs: 7, md: 10 }, fontSize: { md: "23px", xs: "16px" } }} variant="body2">
        <b>BassSuite - Distant</b> was designed in collaboration with <i>Nouri Yetgin</i> from <a href="https://distantofficial.com/" style={{ textDecoration: "underline" }}>Distant</a> during the mixing of the band's new record. It pairs perfectly with <a href="/product/distant-amplifier-suite" style={{ color: "inherit", textDecoration: "underline" }}><b>ToneSuite - Distant</b></a> to create one massive wall of distortion. </Typography>
    </Grid >

    <Grid item id="overview" xs={12} md={6} justifyContent={"center"} alignItems={"center"} sx={{ mt: { xs: 5, md: 0 }, pr: { xs: 0, md: 10 } }} >
      <Box sx={{ height: "100%", display: { xs: "none", md: "flex" }, alignItems: "center", borderRadius: { xs: 0 }, width: "100%", overflow: "hidden" }}>
        <img loading="lazy" src={ecocideBand} alt="Distant performing live" style={{ width: "100%", borderRadius: "20px" }} />
      </Box>

      <Box sx={{ height: "100%", display: { xs: "flex", md: "none" }, alignItems: "center", borderRadius: { xs: 0 }, width: "100%", overflow: "hidden" }}>
        <img loading="lazy" src={ecocideBand} alt="Distant performing live" style={{ width: "100%" }} />
      </Box>
    </Grid >
  </Grid >
}

export default OverviewBanner;
